'use client';

import * as React from 'react';
import Script from 'next/script';
import { twMerge } from 'tailwind-merge';

declare global {
  interface Window {
    Trustpilot?: {
      loadFromElement: (element: HTMLElement) => void;
    };
  }
}

export const TrustpilotMicroReviewWidget = ({
  className,
  styleWidth = '100%',
  theme = 'light',
}: {
  className?: string;
  styleWidth?: string;
  theme?: 'light' | 'dark';
}) => {
  const widgetElementRef = React.useRef<HTMLDivElement>(null);

  return (
    <div className={twMerge('flex justify-center', className)}>
      <Script
        id="trustpilot-widget-script"
        src="https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
        strategy="lazyOnload"
        onReady={() => {
          if (widgetElementRef.current) {
            window.Trustpilot?.loadFromElement(widgetElementRef.current);
          }
        }}
      />
      <div
        ref={widgetElementRef}
        className="trustpilot-widget"
        data-locale="en-US"
        data-template-id="5419b732fbfb950b10de65e5"
        data-businessunit-id="6814e6ec96bb8d7784e2e2ec"
        data-style-height="24px"
        data-style-width={styleWidth}
        data-token="9b7f48e1-05c0-4e20-b45e-cf02de22c2e0"
        data-font-family="Roboto"
        data-theme={theme}
      >
        <a
          href="https://www.trustpilot.com/review/savvy.com"
          target="_blank"
          rel="noopener"
        >
          Trustpilot
        </a>
      </div>
    </div>
  );
};
